import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Quote", href: "#quote" },
  { label: "About", href: "#about" },
  { label: "Founder", href: "#founder" },
  { label: "Why Us", href: "#why-us" },
  { label: "Booking", href: "#booking" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F8FAFC]/85 border-b border-[#1E5F8C]/10"
          : "bg-transparent"
      }`}
    >
      <div className="container-pad mx-auto max-w-7xl flex items-center justify-between py-4 md:py-5">
        <a href="#top" className="flex items-center gap-2.5" data-testid="brand-logo">
          <img
            src="https://customer-assets.emergentagent.com/job_senior-support-pro/artifacts/ajhfd891_IMG_1923.jpg"
            alt="Julicare Health Services"
            className="h-10 w-10 md:h-11 md:w-11 rounded-full object-cover ring-1 ring-[#1E5F8C]/15"
          />
          <span className="font-serif text-base md:text-lg tracking-tight text-[#0F2942] leading-tight hidden sm:inline">
            Julicare Health Services
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm text-[#475569] hover:text-[#1E5F8C] transition-colors"
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#booking"
          className="hidden md:inline-flex items-center justify-center rounded-full bg-[#1E5F8C] text-[#F8FAFC] px-5 py-2.5 text-sm font-medium hover:bg-[#2A75AB] transition-colors"
          data-testid="header-cta-book"
        >
          Book a Consultation
        </a>

        <button
          aria-label="Open menu"
          className="md:hidden p-2 rounded-full hover:bg-[#EEF4F8]"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#1E5F8C]/10 bg-[#F8FAFC]" data-testid="mobile-menu">
          <div className="container-pad mx-auto max-w-7xl py-4 flex flex-col gap-3">
            {NAV.map((i) => (
              <a
                key={i.href}
                href={i.href}
                onClick={() => setOpen(false)}
                className="py-2 text-[#0F2942]"
                data-testid={`mobile-nav-${i.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {i.label}
              </a>
            ))}
            <a
              href="#booking"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-full bg-[#1E5F8C] text-[#F8FAFC] px-5 py-3 font-medium"
              data-testid="mobile-cta-book"
            >
              Book a Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
